<template>
    <div id="app_area01" class="area box menudlg">
        <div class="box1">
            <div class="closebtn" v-on:click="closemenu">閉じる</div>

        <img v-if="menuImage!=''" :src="menuImage" style="width:500px">
        </div>
        <div class="sub-navi-wrap">
            <ul class="sub-navi">
                              <li class="active" v-for="(item,index) in this.$store.getters.subMenuData" :key="index">
                                  <a href="#" v-on:click="contentdisp(item)">
                                     {{item.title}} 
                                  </a>
                              </li>
            </ul>
        </div>
    </div>
</template>

<style scoped lang="scss">
$col1: #000; // クロ（メイン）
$col2: #fff; // 白（メイン）
$col3: #B71C1C; // 赤（メイン）
$col4: #f0b300; // オレンジ（琉大くがにカラー）
$col5: #083674; // 青（メイン）
$col6: #60a1c4; // 水色（brand-name）
$col7: #e3f0f7; // 水色（検索タブ）e0f2fc
$col8: #f28d1a; // オレンジ（一覧ボーダー・フラグ）
$col9: #226296; // 青（背景

@mixin transition {
    -webkit-transition: 0.3s;
    -ms-transition: 0.3s;
    transition: 0.3s;
}

.menudlg {
    background-color: #0e5992;
}
.closebtn{
        position: relative;
    background: rgba(167, 5, 5, 0.555);
    border: 1px solid #0e5992;
    display: block;
    color: #fff;
    padding: 0 0 0 30px;
    margin: 0 5px 7px 0px;
    line-height: 30px;
    border-radius: 20px;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    width:100px;
    cursor: pointer;
        cursor: hand;
    &:hover {
        color: $col4;
    }
}
.sub-navi li{
    list-style:none;
    width:100%;
}
.sub-navi {
        width: 95%;
        padding: 0;
        margin: 3%;

        li {
            //width: 49%;
            display: inline-block;
            list-style: none;
            vertical-align: top;
        }
        a {
            position:relative;
            background: rgba(255,255,255,0.2);
            border:1px solid #36467e;
            display: block;
            color: $col2;
            padding: .2rem 0 .2rem 30px;
            margin: 0 5px 7px 0px;
            line-height: 1.6;
            border-radius: 20px;
            letter-spacing: .05em;
            @include transition;

            &:before {
                counter-increment: list;
                content: "";
                display: block;
                position: absolute;
                left: 10px;
                height: 10px;
                width: 10px;
                border-radius: 50%;
                background: $col2;
                top: 50%;
                -webkit-transform: translateY(-50%);
                -ms-transform: translateY(-50%);
                transform: translateY(-50%);
            }
            &:hover {
                border-color: $col2;
                box-shadow: inset 0 0 20px rgba(255, 255, 255, 0.5), 0 0 20px rgba(255, 255, 255, 0.2);
                outline-color: transparent;
                outline-offset: 12px;
                text-decoration: none;
                -webkit-transform: scale(1.1,1.1);
                -ms-transform: scale(1.1,1.1);
                transform: scale(1.1,1.1);
                @include transition;

                &:before {
                    background: $col4;
                }
            }
        }
}

    .box{
        padding: 5px;
        width:95%;
        height:220px;
        border:solid 1px white;
        display: table;
        pointer-events: auto;
        box-shadow: 2px 2px 4px;

    }
    .box1{
        display:table-cell;
        vertical-align:top;
        max-width:43%;
    }
    .bokeboke{
        opacity: 0.6;/*半透明カラーの透明度*/
        filter: blur(2px);/*ぼかし度*/
    }
    .top{
        position: absolute;
        content:'';
        background-image: url('/top.png');
        background-size: 100%; 
        background-repeat: no-repeat;
        top:0px;
        left:0px;
        z-index: 1;
        width: 600px;
        height: 700px;

    }
    .area{
        position: absolute;
        top:35%;
        left:10px;
        z-index: 2;
        border-radius :10px; 
    }
    .menus{
        position: absolute;
        top:150px;
        left:20px;
        z-index: 2;
    }

    .button {
        background-color: transparent;
        border: 2px solid #fff;
        color: #fff;
        line-height: 50px;
        width:200px;
    }
    .button:hover {
        background-color: rgba(255, 255, 255, .2);
    }

    /* menu animetion */
    .map-enter-active, .map-leave-active{
        transition:opacity .5s;
    }
    .map-enter, .map-leave-to {
        opacity:0;
    }


/* ボタン */
.skerton{
  display: inline-block;
  padding: 15px;
  text-decoration: none;
  transition: .3s;
  margin: 5px;
}
.skerton.default{
  color: #ffffff;
  border: 2px solid #fff;
  padding: 3px 60px;
}
.skerton.default:hover{
  color: #1E1C93;
  background: #fff;
}
.skerton.default.opacity:hover{
  color: #fff;
  background: rgba(255,255,255,.3);
}
.skerton2 {
  display: inline-block;
  padding: 3px 60px;
  background-color: rgba(255, 255, 255, .2);
  border-radius: 4px;
  color: #fff;
  box-shadow: 0 3px 3px rgba(0, 0, 0, .2), inset 0 1px 1px rgba(255, 255, 255, .7);
  text-shadow: 0px 1px 0px rgba(0, 0, 0, .4);
  transition:.3s;
  margin: 5px;
}
.skerton2:hover {
  background-color: rgba(255, 255, 255, .3); 
}
</style>
<script>

import {API_URL} from '@/services/config'
export default {
  name: 'SubMenu',
  props: {
    content: String,
    submenu:[],
  },
  computed:{
      menuImage(){
          return this.$store.getters.subMenuImage;
      }
  },
  methods:{
      closemenu(){
          this.$store.dispatch('upIsSubMenu',false);
          this.$store.dispatch('upIsTopBoke',false);
      },
      contentdisp(item){
           var self=this;
        //   self.menuImage = self.$store.getters.subMenuImage;
          var params = new URLSearchParams();
          params.append('menu_id',item.menu_id);
          self.$axios.post(`${API_URL}/search/getcontent`, params)
          .then((res)=>{
              if(res.data.contentValue === null)
                {
                  this.$store.dispatch('upIsSearchBox',true);
                  return ;
                }
              this.$store.dispatch('upContent',(res.data.contentValue === null) ? '' : res.data.contentValue);
              this.$store.dispatch('upIsSearchBox',false);
          }).catch(err=>{
            console.log('err end');
          });
      }
  }
}
</script>